import React from 'react';
import { useSelector } from 'react-redux';
import { translatePage } from '../../../../../utils/services/translate';
import './styles.scss';



const ErrorDisplay = ({onRetry, onChangeOption, isProcessing }) => {
  const translations = useSelector(state => state.Layout.translations);
  const language = useSelector(state => state.Layout.language);

  return (
    <div className="container min-height-100 d-flex justify-content-center align-items-center">
      <div className="error-container">
        <div className="row">
          <div className="col-12 text-center">
            <h1 className="mt-5 text-center text-danger">
              {translatePage(
                translations,
                language,
                "paymentSelectionPage",
                "technicalIssueh1"
              )}
            </h1>
          </div>
          <div className="row">
            <div className="col-12 pt-3 text-center">
              <button
                className="btn btn-secondary w-100 text-m p-3"
                onClick={onChangeOption}
                disabled={isProcessing}
              >
                {translatePage(
                  translations,
                  language,
                  "paymentSelectionPage",
                  "changePaymentOption"
                )}
              </button>
            </div>
            <div className="col-12 pt-3 text-center">
              <button
                className="btn btn-success w-100"
                onClick={onRetry}
                disabled={isProcessing}
              >
                {translatePage(
                  translations,
                  language,
                  "paymentSelectionPage",
                  "tryAgainButton"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorDisplay;